import React, { useMemo } from "react";

function getField(item, keys, fallback = "") {
  for (const key of keys) {
    if (item?.[key] !== undefined && item?.[key] !== null && item?.[key] !== "") {
      return item[key];
    }
  }
  return fallback;
}

function cleanHost(url) {
  try {
    const parsed = new URL(url);
    return parsed.hostname.replace(/^www\./, "").toLowerCase();
  } catch {
    return "";
  }
}

function detectSource(visitor) {
  const utmSource = String(
    getField(visitor, ["utm_source", "utmSource"], "")
  ).toLowerCase();

  const savedSource = String(
    getField(visitor, ["source", "traffic_source", "trafficSource"], "")
  ).toLowerCase();

  const referrerUrl = getField(
    visitor,
    ["referrer_url", "referrer", "referer", "referrerUrl"],
    ""
  );

  const host = cleanHost(referrerUrl);

  const combined = `${utmSource} ${savedSource} ${host}`;

  if (!combined.trim() || combined.includes("localhost")) return "Direct";
  if (combined.includes("google")) return "Google";
  if (combined.includes("bing")) return "Bing";
  if (combined.includes("facebook") || combined.includes("fb.")) return "Facebook";
  if (combined.includes("instagram")) return "Instagram";
  if (combined.includes("pinterest")) return "Pinterest";
  if (combined.includes("youtube") || combined.includes("youtu.be")) return "YouTube";
  if (combined.includes("etsy")) return "Etsy";
  if (combined.includes("teacherspayteachers") || combined.includes("tpt")) return "TPT";
  if (combined.includes("linkedin")) return "LinkedIn";
  if (combined.includes("twitter") || combined.includes("x.com")) return "X / Twitter";

  if (host) return host;

  return "Direct";
}

function AdminTrafficSources({ visitors = [] }) {
  const trafficData = useMemo(() => {
    const counts = {};

    visitors.forEach((visitor) => {
      const source = detectSource(visitor);
      counts[source] = (counts[source] || 0) + 1;
    });

    const list = Object.entries(counts)
      .map(([source, total]) => ({
        source,
        total,
        percent: visitors.length ? Math.round((total / visitors.length) * 100) : 0,
      }))
      .sort((a, b) => b.total - a.total);

    return list;
  }, [visitors]);

  const max = trafficData.length ? trafficData[0].total : 1;

  return (
    <div className="mc-traffic-source-card">
      {trafficData.length ? (
        trafficData.slice(0, 7).map((item) => {
          const width = Math.max(6, Math.round((item.total / max) * 100));

          return (
            <div className="mc-traffic-row" key={item.source}>
              <div className="mc-traffic-top">
                <span>{item.source}</span>
                <strong>
                  {item.total} <small>{item.percent}%</small>
                </strong>
              </div>

              <div className="mc-traffic-bar">
                <i style={{ width: `${width}%` }} />
              </div>
            </div>
          );
        })
      ) : (
        <div className="mc-traffic-empty">
          No traffic source data yet. Sources will appear after visitor tracking stores referrer or UTM data.
        </div>
      )}
    </div>
  );
}

export default AdminTrafficSources;